import { useEffect, useState } from "react";

import styles from "@styles/home-configurations.module.scss";
import {
  MiniCheck,
  MiniInfo,
  Picture,
  SuccessIcon,
} from "shared/components/Icons";
import { Button, Input, Loading } from "@components";
import { If } from "shared/components/control-statements";

import classNames from "classnames/bind";
import { AssetsAPI } from "providers/AssetsAPI";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import BrandUnits from "./BrandUnits";
const css = classNames.bind(styles);

const BannersAdd = ({
  section,
  item = {},
  onClose,
  onSave,
  onFinish,
  onDeleteItem,
}) => {
  const [steps] = useState([
    { key: "mobile", label: "Imagem Mobile", show: true },
    {
      key: "desktop",
      label: "Imagem Desktop",
      show: section.presentationFormat !== "HORIZONTAL_SCROLL",
    },
    {
      key: "BRANDS_UNITS",
      label: "Marcas e unidades",
      show: true,
    },
    { key: "link", label: "Link banner", show: true },
  ]);
  const [selectedStep, setSelectedStep] = useState("mobile");
  const [showSuccess, setShowSuccess] = useState(false);
  const [banner, setBanner] = useState(item || {});
  const [holdingId, setHoldingId] = useState(null);
  const [loading, setLoading] = useState(false);

  const getHoldingId = async () => {
    const holdingId = await EnvironmentStorage.getEnvironmentHoldingId();
    setHoldingId(holdingId);
  };

  useEffect(() => {
    getHoldingId();
  }, []);

  const environment = EnvironmentStorage.getEnvironment();

  const isCabana =
    environment?.brand?.alias === "cabana-burger779" ||
    environment?.alias === "cabana-burger779";

  const isCiaTC = holdingId && holdingId === 811;

  const dimensions = {
    desktop: isCabana
      ? { width: 2500, height: 600 }
      : { width: 1920, height: 400 },
    mobile: isCabana
      ? { width: 1080, height: 1920 }
      : isCiaTC
      ? { width: 1080, height: 500 }
      : { width: 1080, height: 500 },
  };

  const getDimensions = () => {
    if (selectedStep === "mobile") {
      return `(${dimensions.mobile.width}x${dimensions.mobile.height})`;
    }

    if (selectedStep === "desktop") {
      return `(${dimensions.desktop.width}x${dimensions.desktop.height})`;
    }
  };

  const validateImageSize = async (file, width, height, isCabana, isCiaTC) => {
    if (!file) {
      throw new Error("Arquivo inválido.");
    }

    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const widthImage = img.naturalWidth;
        const heightImage = img.naturalHeight;

        if (
          (widthImage !== width || heightImage !== height) &&
          !isCabana &&
          !isCiaTC
        ) {
          setLoading(false);
          reject(new Error(`A imagem deve ter a dimensão ${width}x${height}`));
        }
        resolve(file);
      };
    });
  };

  const urlRegex =
    /^https?:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?$/;

  const handleSetImage = async (e, mode) => {
    const file = e.target.files[0];
    setLoading(true);

    try {
      const res = await validateImageSize(
        file,
        selectedStep === "mobile"
          ? dimensions.mobile.width
          : dimensions.desktop.width,
        selectedStep === "mobile"
          ? dimensions.mobile.height
          : dimensions.desktop.height,
        isCabana,
        isCiaTC
      );
      const uri = await sendFile(res);
      setBanner({ ...banner, [mode]: uri });
    } catch (err) {
      alert({ text: err.message });
    }
  };

  const sendFile = async (file) => {
    const maxFileSize = 1500;
    const fileSize = file.size / 1024;
    const fileType = file.type;

    if (fileSize > maxFileSize) {
      setLoading(false);
      alert({ text: `Escolha um arquivo com no máximo ${maxFileSize} KB.` });
      return false;
    }

    const pattern = /^(image\/(png|jpeg|svg\+xml))$/i;

    if (!fileType.match(pattern)) {
      setLoading(false);
      alert({
        text: "Arquivo inválido. Utilize algum dos seguintes formatos: .png, .jpg, .jpeg, .svg",
      });
      return false;
    }

    return await new Promise((resolve) => {
      let reader = new FileReader();
      reader.onload = async (readerEvent) => {
        const response = await AssetsAPI.PostAssets({
          mime_type: fileType,
          file: readerEvent.target.result.split("base64,")[1],
        });
        resolve(response.getData(null));
        setLoading(false);
      };
      reader.readAsDataURL(file);
    });
  };

  return (
    <>
      <div className={styles.homeHeader}>
        <div className="d-flex flex-column">
          <p className={styles.title}>Adicionar banner</p>
          <p className={styles.subtitle}>{section.title}</p>
        </div>
        <div className="d-flex align-center">
          <div className={styles.close} onClick={onClose}>
            <i className="fas fa-times" />
          </div>
        </div>
      </div>

      <If cond={!showSuccess}>
        <div className={styles.homeSidebar}>
          <ul>
            {steps
              .filter(({ show }) => show)
              .map(({ key, label }) => {
                const isSelected = selectedStep === key;
                const isCompleted = banner[key];

                return (
                  <li
                    key={String(key)}
                    className={css({ selected: isSelected })}
                    onClick={() => setSelectedStep(key)}
                  >
                    <div className="d-flex align-center justify-between w-100">
                      <span>{label}</span>
                      <If cond={key !== "link" && key !== "BRANDS_UNITS"}>
                        {isCompleted ? <MiniCheck /> : <MiniInfo />}
                      </If>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </If>

      <If cond={!showSuccess}>
        <div className={styles.scrollContainer}>
          <If cond={selectedStep === "mobile"}>
            <div className={styles.configContainer}>
              <p className={styles.title}>Selecione a imagem abaixo</p>
              <label
                htmlFor="upload"
                className={css({
                  uploadBanner: true,
                  hasImage: !!banner?.mobile,
                  uploading: loading,
                })}
              >
                <If cond={loading}>
                  <Loading />
                </If>
                <If cond={!loading}>
                  <If cond={banner?.mobile}>
                    <img
                      src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.mobile}`}
                      class="w-100"
                    />
                  </If>
                  <If cond={!banner?.mobile}>
                    <div className={styles.icon}>
                      <Picture />
                    </div>
                    <div className={styles.selectFile}>
                      <p>Selecione o arquivo</p>
                      <span>&nbsp;para fazer upload</span>
                    </div>
                    <span className={styles.fileAccepted}>
                      JPG, JPEG, PNG, SVG {getDimensions()}
                    </span>
                    <span className={styles.maxSize}>
                      Peso máximo do arquivo: 1,5MB
                    </span>
                  </If>
                  <input
                    type="file"
                    id="upload"
                    accept=".png, .jpeg, .jpg, .svg"
                    onChange={(e) => handleSetImage(e, "mobile")}
                  />
                </If>
                <If cond={banner?.mobile}>
                  <div
                    className={styles.edit}
                    style={{ pointerEvents: "none" }}
                  >
                    <Button onClick={() => {}}>Alterar imagem</Button>
                  </div>
                </If>
              </label>
            </div>
          </If>

          <If cond={selectedStep === "desktop"}>
            <div className={styles.configContainer}>
              <p className={styles.title}>Selecione a imagem abaixo</p>
              <label
                htmlFor="upload"
                className={css({
                  uploadBanner: true,
                  hasImage: !!banner?.desktop,
                  uploading: loading,
                })}
              >
                <If cond={loading}>
                  <Loading />
                </If>
                <If cond={!loading}>
                  <If cond={banner?.desktop}>
                    <img
                      src={`${process.env.REACT_APP_ASSETS_URL}/${banner?.desktop}`}
                      class="w-100"
                    />
                  </If>
                  <If cond={!banner?.desktop}>
                    <div className={styles.icon}>
                      <Picture />
                    </div>
                    <div className={styles.selectFile}>
                      <p>Selecione o arquivo</p>
                      <span>&nbsp;para fazer upload</span>
                    </div>
                    <span className={styles.fileAccepted}>
                      JPG, JPEG, PNG, SVG {getDimensions()}
                    </span>
                    <span className={styles.maxSize}>
                      Peso máximo do arquivo: 1,5MB
                    </span>
                  </If>
                  <input
                    type="file"
                    id="upload"
                    accept=".png, .jpeg, .jpg, .svg"
                    onChange={(e) => handleSetImage(e, "desktop")}
                  />
                </If>
                <If cond={banner?.desktop}>
                  <div
                    className={styles.edit}
                    style={{ pointerEvents: "none" }}
                  >
                    <Button onClick={() => {}}>Alterar imagem</Button>
                  </div>
                </If>
              </label>
            </div>
          </If>

          <If cond={selectedStep === "BRANDS_UNITS"}>
            <BrandUnits
              data={banner.target}
              onChange={(data) =>
                setBanner((prev) => ({
                  ...prev,
                  target: {
                    brands: data.brands || [],
                    units: data.units || [],
                    channels: data.channels || [],
                  },
                }))
              }
            />
          </If>

          <If cond={selectedStep === "link"}>
            <div className={styles.configContainer}>
              <p className={styles.title}>
                Configurar link do banner <span>(opcional)</span>
              </p>
              <Input
                className="mt-20"
                placeholder="https://exemplo.com"
                value={banner.link}
                onChange={(e) => {
                  setBanner((prev) => ({ ...prev, link: e.target.value }));
                }}
              />
            </div>
          </If>
        </div>
      </If>

      <If cond={!showSuccess}>
        <div className={styles.footer}>
          {item?.id && (
            <Button
              design="danger"
              className="mr-10"
              onClick={() => onDeleteItem(banner)}
            >
              Remover banner
            </Button>
          )}
          {selectedStep !== "link" && (
            <Button
              design="primary"
              onClick={() => {
                console.log(selectedStep);
                if (selectedStep === "BRANDS_UNITS")
                  return setSelectedStep("link");
                if (section.presentationFormat === "HORIZONTAL_SCROLL")
                  return setSelectedStep("BRANDS_UNITS");
                if (selectedStep === "mobile") setSelectedStep("desktop");
                else if (selectedStep === "desktop")
                  setSelectedStep("BRANDS_UNITS");
                else setSelectedStep("link");
              }}
              disabled={
                (!banner.mobile && selectedStep === "mobile") ||
                (!banner.desktop && selectedStep === "desktop")
              }
            >
              Próximo
            </Button>
          )}
          {selectedStep === "link" && (
            <Button
              design="primary"
              onClick={() => {
                onSave(banner);
                setShowSuccess(true);
              }}
              disabled={
                !banner.mobile ||
                (section.presentationFormat !== "HORIZONTAL_SCROLL" &&
                  !banner.desktop)
              }
            >
              Adicionar
            </Button>
          )}
        </div>
      </If>

      <If cond={showSuccess}>
        <div className={styles.successContainer}>
          <div className={styles.successIcon}>
            <SuccessIcon size={14} />
          </div>
          <p className={styles.successMessage}>
            Banner adicionado com sucesso.
          </p>

          <div className={styles.footer}>
            <Button design="primary" onClick={onFinish}>
              Fechar
            </Button>
          </div>
        </div>
      </If>
    </>
  );
};

export default BannersAdd;
